import {routerMiddleware} from 'connected-react-router';
import promiseMiddleware from 'redux-promise-middleware';
import {configureStore, getDefaultMiddleware} from '@reduxjs/toolkit';
import {createReduxEnhancer} from '@sentry/react';

import history from 'utils/history';
import createRootReducer from './reducers';
import {analyticsMiddleware} from './middleware/analytics';

/** @module store */

/**
 * The Sentry Redux enhancer. Documentation: {@link https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/redux/}
 */
const sentryReduxEnhancer = createReduxEnhancer();

/**
 * Creates the redux store.
 */
export function createStore(initialState = {}) {
    const store = configureStore({
        reducer: createRootReducer(history),
        middleware: () =>
            getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: false, // disabled due to timeouts in concourse
            }).concat(
                routerMiddleware(history),
                analyticsMiddleware.middleware,
                promiseMiddleware
            ),
        preloadedState: initialState,
        enhancers: [sentryReduxEnhancer],
    });

    return store;
}
const store = createStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
